// extracted by mini-css-extract-plugin
module.exports = {"overlay-style":"style_overlay-style__1S3kI","content":"style_content__2QAI6"};